import Loader from 'components/Loader';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router';
import { isValidToken } from 'utils';

const Private = () => {
	const isAuth = isValidToken();

	return isAuth ? (
		<Suspense fallback={<Loader />}>
			<Outlet />
		</Suspense>
	) : (
		<Navigate to="/login" />
	);
};

export default Private;
